import {useSyncExternalStore} from 'react';
import {
  isEffectivelyOffline,
  isSimulatedOffline,
  subscribeConnectivity,
} from 'src/offline/connectivity';

export interface UseConnectivityResult {
  isOffline: boolean;
  isSimulated: boolean;
}

/**
 * React hook exposing live connectivity state (real or simulated). Backed by
 * `src/offline/connectivity.ts` via `useSyncExternalStore` so updates are
 * synchronous with browser online/offline events and simulated toggles.
 */
export const useConnectivity = (): UseConnectivityResult => {
  const isOffline = useSyncExternalStore(
    subscribeConnectivity,
    isEffectivelyOffline
  );
  const isSimulated = useSyncExternalStore(
    subscribeConnectivity,
    isSimulatedOffline
  );

  return {isOffline, isSimulated};
};
